import React from 'react'
import { Form, Row, Col, Input, Button, Typography, message } from 'antd'
import { withRouter } from 'react-router'
import { reqResetPwd } from '../../api'

const { Title } = Typography

class ResetPwd extends React.Component {
    onFinish = async (values) => {
        const uidb64 = this.props.match.params.uidb64
        const token =  this.props.match.params.token
        const data = {username: values.username, password: values.password, confirm_password: values.confirm_password}
        const reset_results = await reqResetPwd(uidb64, token, data)
        if (reset_results.code === 0) {
            message.success('Password reset success. You can login in now.')
            this.props.history.push('/success/resetPwd')
        } else {
            message.success('Password reset failed.')
        }
    }

    render() {
        const formItemLayout = {
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 14,
            },
        }
        
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 14,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        }

        return (
            <React.Fragment>
            <Row justify="center">
                <Col>
                    <Title level={3}>Password Reset</Title>
                </Col>
            </Row>
            <Row justify="center">
                <Col span={16}>
                    <Form { ...formItemLayout } 
                        ref={this.formRef} 
                        name="resetpwd" 
                        onFinish={this.onFinish} 
                        scrollToFirstError
                    >
                        <Form.Item name="username" label="Username"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Username',
                                },
                                {
                                    type: 'string'
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                        
                        <Form.Item
                            name="password"
                            label="Password"
                            extra="Enter at least 8 uppercase/lowercase letters, numbers, or special characters."
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                                {
                                    type: 'string',
                                },
                                {
                                    min: 8,
                                    max: 16,
                                    whitespace: true,
                                    pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                    message: 'Letters length should between 8 and 16, with uppercase/lowercase letters, numbers, or special characters.'
                                }
                            ]}
                            hasFeedback
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            name="confirm_password"
                            label="Confirm Password"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm your password!',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('The two passwords that you entered do not match!');
                                    },
                                }),
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>
                        
                        <Form.Item label="Captcha">
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item
                                        name="captcha"
                                        noStyle
                                        //rules={[{ required: true, message: 'Please input the captcha you got!' }]}
                                    >
                                    <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Button>Get captcha</Button>
                                </Col>
                            </Row>
                        </Form.Item>
                        <Form.Item {...tailFormItemLayout}>
                            <Button type="primary" htmlType="submit" className="reset-pwd-button" block>Submit</Button>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </React.Fragment>
        )
    }
}

export default withRouter(ResetPwd)